import ConsentForm, { Values as FormValues } from '../forms/consent';
import ModalV2 from './modal-v2';

interface ConsentCreateModalProps {
  open: boolean;
  loading?: boolean;
  fixedType?: 'Mentor' | 'Founder';
  onClose: () => void;
  onSubmit: (values: FormValues, callback: () => void) => void;
}

export function ConsentCreateModal({
  open,
  loading = false,
  fixedType,
  onClose,
  onSubmit,
}: ConsentCreateModalProps) {
  const handleSubmit = (values: FormValues) => {
    onSubmit(values, onClose);
  };

  return (
    <ModalV2
      open={open}
      onClose={onClose}
      width='720px'
      titleProps={{
        title: 'New Commitment',
      }}>
      <ConsentForm
        title=''
        fixedType={fixedType}
        loading={loading}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </ModalV2>
  );
}
